import { useQuery } from 'react-query';

import type { FreelancerAvailableTime } from '../types';

type UseGetFreelancerAvailableTimeHandler = {
  data?: Array<FreelancerAvailableTime>;
  error: string | null;
  isLoading: boolean;
};

type UseGetFreelancerAvailableTimeInput = {
  date: string;
};

const UseGetFreelancerAvailableTime = (
  params: UseGetFreelancerAvailableTimeInput,
): UseGetFreelancerAvailableTimeHandler => {
  const { isLoading, error, data } = useQuery<
    Array<FreelancerAvailableTime>,
    string
  >(['get-freelancer-available-time', params.date], async () => {
    const response = await fetch(`/api/available_days/week/${params.date}/`);
    if (response.ok) return response.json();
    throw new Error('Something went wrong');
  });

  return { data, error, isLoading };
};

export default UseGetFreelancerAvailableTime;
